<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" label-width="80px">
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="品牌:">
            <el-radio-group v-model.number="searchForm.brand_id" @change="checkInput">
              <el-radio :label="1">N牌</el-radio>
              <el-radio :label="2">S牌</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="10">
          <el-form-item label="日期:">
            <el-date-picker v-model="searchForm.day" type="date"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="單號:">
            <el-input v-model="searchForm.id" style="width: 50%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="12">
          <el-form-item label="店櫃:">
            <el-select v-model="searchForm.shopKey" filterable>
              <el-option
                v-for="item in shopList"
                :label="item.name"
                :value="item._key"
                :key="item._key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="狀態:">
            <el-radio-group v-model.number="searchForm.status">
              <el-radio :label="1">完成</el-radio>
              <el-radio :label="2">作廢</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="12">
          <el-button type="primary" icon="el-icon-search" @click="fetchOrderReturnList"
            >查詢</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :lg="6" :offset="18">
        <el-button type="primary" @click="dialogFormVisible = true">報表</el-button>
        <el-dialog title="報表" :visible.sync="dialogFormVisible" width="40%" center>
          <el-form :v-model="excelForm" :rules="rules" label-width="90px">
            <el-row justify="center" align="center">
              <el-col :span="22" :offset="2">
                <el-form-item label="品牌:" prop="brand_id">
                  <el-radio-group
                    v-model.number="excelForm.brand_id"
                    @change="excelCheckInput"
                  >
                    <el-radio :label="1">N牌</el-radio>
                    <el-radio :label="2">S牌</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="22" :offset="2">
                <el-form-item label="日期間格:">
                  <el-date-picker
                    v-model="excelForm.date"
                    type="daterange"
                    range-separator="到"
                    start-placeholde="開始日期"
                    end-placeholde="結束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="22" :offset="2">
                <el-form-item label="店櫃:">
                  <el-select v-model="excelForm.shopKey" filterable>
                    <el-option
                      v-for="item in excelShopList"
                      :label="item.name"
                      :value="item._key"
                      :key="item._key"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-progress :text-inside="true" :stroke-width="26" :percentage="percentData" v-if="start"></el-progress>

          <el-row justify="center" align="center"> </el-row>

          <span slot="footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="downExcel">匯 出</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :lg="22">
        <el-table
          :data="
            orderReturnList.slice((currentPage - 1) * pagesize, currentPage * pagesize)
          "
          empty-text="暫無數據"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column prop="create_datetime" label="日期"> </el-table-column>
          <el-table-column label="單號" prop="id"></el-table-column>
          <el-table-column label="店櫃" prop="shop_name"></el-table-column>
          <el-table-column label="會員" prop="member_name"></el-table-column>
          <el-table-column label="金額" prop="total"></el-table-column>
          <el-table-column label="狀態">
            <template slot-scope="scope">
              <el-tag type="info" effect="dark">
                {{ scope.row.status == 1 ? "完成" : null }}
                {{ scope.row.status == 2 ? "作廢" : null }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="詳細">
            <template slot-scope="scope">
              <el-button
                type="info"
                icon="el-icon-more"
                @click="detailTabs(scope.$index, scope.row)"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total1"
          @current-change="current_change"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import toExcel from "@/excel/json2excel";
export default {
  name: "search",
  data() {
    return {
      searchForm: {
        brand_id: null,
        shopKey: "",
        day: "",
        id: "",
        status: null,
      },
      orderReturnList: [],
      excelForm: {
        brand_id: 1,
        date: [],
        shop_key: "",
      },
      shopList: [],
      excelShopList: [],
      date: "",
      orderKey: "",
      total1: 0,
      currentPage: 1,
      pagesize: 10,
      bid: {},
      excelBrandId: {},
      dialogVisible: false,
      dialogFormVisible: false,
      itemName: "",
      itemQty: "",
      itemId: "",
      items: [],
      start: false,
      percentData: 0 ,
      orderExcel: [],
      productDetail: [],
      rules: {
        brand_id: [{ required: true, message: "請輸入品牌", trigger: "change" }],
      },
    };
  },
  computed: mapGetters([
    "getOrderReturnList",
    "getShopList",
    "getShopDetail",
    "getOrderReturnExcel",
    "getProductDetail",
  ]),
  methods: {
    ...mapActions([
      "fetchOrderReturnList",
      "fetchShop",
      "fetchOrderChangExcel",
      "fetchShopDetail",
      "fetchProductDetail",
    ]),
    async fetchOrderReturnList() {
      if (this.searchForm.day.length != 0) {
        this.date = moment(this.searchForm.day).format("YYYY-MM-DD");
      } else {
        this.date = "";
      }
      const data = {
        type: 1,
        brand_id: this.searchForm.brand_id,
        create_datetime: this.date,
        shop_key: this.searchForm.shopKey,
        id: this.searchForm.id,
        status: this.searchForm.status,
      };
      await this.$store.dispatch("fetchOrderReturnList", data);
      this.orderReturnList = this.getOrderReturnList;
      this.total1 = this.orderReturnList.length;
      for (let i = 0; i < this.orderReturnList.length; i++) {
        console.log(this.orderReturnList[i].status);
      }
    },
    async fetchShopList() {
      if (this.searchForm.brand_id != 0) {
        this.bid = {
          brand_id: this.searchForm.brand_id,
        };
      } else {
        this.bid = {};
      }
      
      await this.$store.dispatch("fetchShop", this.bid);
      this.shopList = this.getShopList;
    },
    
     async excelQueryShop() {
      
      if (this.excelForm.brand_id != null) {
        this.excelBrandId = {
          brand_id: this.excelForm.brand_id,
        };
      } else {
        this.excelBrandId = {};
      }
      
      await this.$store
        .dispatch("fetchShop", this.excelBrandId)
        .then(() => {
          this.excelShopList = this.getShopList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkInput() {
      this.fetchShopList();
    },
    excelCheckInput() {
      this.excelQueryShop();
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `background-color: gray;color: #000;`;
      }
    },
    detailTabs(index, row) {
      this.orderKey = row._key;
      this.$emit("detailTabs", this.orderKey);
    },
    async downExcel() {
      this.start = true;
        await this.$message({
        type: 'info',
        message: '完成需等待時間完成匯出',
      })
      this.percents()
      if (this.excelForm.date.length != 0) {
        this.startDay = moment(this.excelForm.date[0]).format("YYYY-MM-DD");
        this.endDay = moment(this.excelForm.date[1]).format("YYYY-MM-DD");
      } else {
        this.startDay = "";
        this.endDay = "";
      }
      const data = {
        brand_id: this.excelForm.brand_id,
        start_date: this.startDay,
        end_date: this.endDay,
        shop_key: this.excelForm.shopKey,
      };
      await this.$store.dispatch("fetchOrderReturnExcel", data);

      this.orderExcel = this.getOrderReturnExcel;

      

      this.DataExcel(this.orderExcel, this.startDay, this.endDay, this.excelForm.brand_id);
      this.start = false;
    },

    percents(){
     
        this.percentData += 20
        var self = this;
        setTimeout(function () {
          self.percentData += 20
        }, 10000)
        setTimeout(function () {
          self.percentData += 20
        }, 20000)
        setTimeout(function () {
          self.percentData += 20
        }, 30000)
        setTimeout(function () {
          self.percentData += 20
        }, 40000)
        
    
       
    },

    async DataExcel(datas, statDay, endDay, brand_id) {
      const th = [
        "會員卡號",
        "會員姓名",
        "店櫃代碼",
        "店櫃名稱",
        "退貨日期",
        "退貨單號",
        "原訂單單號",
        "品號",
        "品名",
        "退貨數量",
        
      ];
      const filterVal = [
        "card_number",
        "member_name",
        "shop_id",
        "shop_name",
        "create_datetime",
        "id",
        "order_id",
        "item_id",
        "item_name",
        "item_qty",
        
      ];
      const data = datas.map((v) => filterVal.map((k) => v[k]));
      let tableName = "退貨單";
      if (statDay != "" && endDay != "") {
        tableName = tableName + statDay + "-" + endDay;
      }
      if (brand_id == 1) {
        tableName = "N牌" + tableName;
      }
      if (brand_id == 2) {
        tableName = "S牌" + tableName;
      }
      const [fileName, fileType, sheetName] = [tableName, "xlsx", tableName];
      toExcel({
        th,
        data,
        fileName,
        fileType,
        sheetName,
      });
    },
  },
  created() {
    this.fetchShopList();
    this.excelQueryShop();
  },
};
</script>

<style lang="less" scoped></style>
